
import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { post, get } from '../../../helpers/api_helper';
import { POST_UPDATE_USER_PROFILE, GET_MY_PROFILE } from '../../../helpers/url_helper';
import { getUserDetail, setUserDetail } from '../../../helpers/Helper';
import { toast } from 'react-toastify';
import useMounted from '../../../hooks/useMounted';
import Loader from '../../../components/Loader';
import SimpleReactValidator from 'simple-react-validator';
import { useTranslation } from 'react-i18next';

const Setting = (props) => {
    const { t } = useTranslation();

    const [isLoader, setLoader] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ companyName: '', name: '', email: '', countryId: '', mobileNo: '' });
    const simpleValidator = useRef(new SimpleReactValidator());
    const [CountriesList, SetCountriesList] = useState([]);
    const [UserDetail] = useState(getUserDetail());
    const [, forceUpdate] = useState();
    
    useMounted(() => {
        async function get_detaile() {
            await get_app_setting();
            setLoader(1);
        }
        get_detaile();
    }, [])

    const get_app_setting = async () => {
        var res_data = await get(GET_MY_PROFILE);
        if (res_data.status) {
            setInputs(res_data.data.profile);
            SetCountriesList(res_data.data.countriesList)
            setUserDetail(UserDetail);
        } else {
            toast.error(res_data.message);
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_UPDATE_USER_PROFILE, form_inputs, {});
            if (res_data.status) {
                await get_app_setting();
                toast(res_data.message);
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }

    return (
        <>
            {!isLoader && <Loader />}
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">{t('myProfile.myProfile')}</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('myProfile.form.companyName')} *</label>
                                    <input name="companyName" value={form_inputs.companyName} onChange={handleInputChange} className="form-control" type="text" />
                                    {simpleValidator.current.message('', form_inputs.companyName, 'required',{messages : {required : t('myProfile.formError.companyNameRequired')}})}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('myProfile.form.fullName')} *</label>
                                    <input name="name" value={form_inputs.name} onChange={handleInputChange} className="form-control" type="text" />
                                    {simpleValidator.current.message('', form_inputs.name, 'required',{messages : {required : t('myProfile.formError.fullNameRequired')}})}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('myProfile.form.mobileNumber')} *</label>
                                    <input name="mobileNo" value={form_inputs.mobileNo} onChange={handleInputChange} className="form-control" type="text" />
                                    {simpleValidator.current.message('', form_inputs.mobileNo, 'required|numeric|min:10|max:10', {messages : {
                                            required : t('myProfile.form.mobileNumberRequired'),
                                            numeric : t('myProfile.form.mobileNumberNumeric'),
                                            min : t('myProfile.form.mobileNumberMin'),
                                            max : t('myProfile.form.mobileNumberMax'),
                                        }})}                                
                                    </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('myProfile.form.emailAddress')} </label>
                                    <input name="email" value={form_inputs.email} disabled className="form-control" type="text" />
                                </div>
                                <div className="mb-3">
                                    <label for="email" className="form-label text-capitalize">{t('myProfile.form.selectCountry')}</label>
                                    <select name="countryId" value={form_inputs.countryId} onChange={handleInputChange} className="form-control">
                                        <option value="">{t('myProfile.form.selectCountry')}</option>
                                        {CountriesList && CountriesList.map((value, index) => {
                                            return (<option key={index} value={value.countryId}>{value.countryName}</option>)
                                        })}
                                    </select>
                                    {simpleValidator.current.message('country', form_inputs.countryId, 'required',{messages : {required : t('myProfile.formError.selectCountryRequired')}})}
                                </div>
                                
                                <div className='text-center mt-5'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('update')}
                                    </button>
                                    <Link to="/dashboard" className="btn btn-danger ms-3"> {t('cancel')}</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Setting;